module.exports = __webpack_public_path__ + "assets/ic_tree06.32c4731d.svg";